import { Directional } from '../../../components/Directional/Directional';

# Ad Sync

Ad Sync is an aggregation solution designed to provide seamless and efficient access to SEEK’s employment marketplace.
It automatically posts SEEK job ads by ingesting and enriching job requisition data from your software.

Each job requisition in your software is shared with SEEK as a position and posted as a job ad.

## Before you begin

Ad Sync will roll out in phases,
starting with partners in our Partner Program.
If we haven’t contacted you about this solution,
don’t commence your build until you receive confirmation that we can support the certification and release of your integration.
We’ll get in touch with our remaining partners once Ad Sync reaches general availability.

Our Ad Sync documentation includes directional guidance regarding features that may not be part of the initial release.
These instances are denoted by a <Directional /> tag.

Your software requires a Job Posting relationship with a [test hirer account] to build and test Ad Sync.
Review the [Developer Dashboard hirers page] and [contact SEEK’s support team] to configure the relationship if it is missing.

Once you have completed your internal build and test phases,
contact SEEK’s support team to certify your integration and grant access to Ad Sync for production hirer accounts.
This is a separate pre-release step to ensure integration compatibility and quality.

[contact SEEK’s support team]: https://au.employer.seek.com/contactus
[Developer Dashboard hirers page]: /manage/hirers
[test hirer account]: /introduction#integration-process

## SEEK posting configuration

Ad Sync allows hirers to set configurable rules affecting how jobs are posted.
Hirers can:

- Set default preferences such as branding and key selling points to use on Ad Sync job ads
- Select higher-performance ad products to promote harder to fill positions based on details such as position title or salary range
- Opt to exclude certain positions from automated posting
- Configure default apply method
- Configure [position routing]
- Configure job ad auto refresh

Your software may include a call to action for hirers to manage their posting rules by contacting SEEK.
Our support staff will help to set up rules that match their posting intent.

## Next steps

| Section                        | Description                                                        |
| :----------------------------- | :----------------------------------------------------------------- |
| [Review user experience guide] | Understand the recommended user experience for Ad Sync integration |
| [Sync positions]               | Send position data to SEEK                                         |
| [Display job ads]              | Receive job ad data from SEEK                                      |
| [Transition hirers]            | Migrate from existing Ad Sync sources                              |

[Review user experience guide]: /use-cases/job-posting/ad-sync/user-experience-guide
[Sync positions]: /use-cases/job-posting/ad-sync/sync-positions
[Display job ads]: /use-cases/job-posting/ad-sync/display-job-ads
[position routing]: /use-cases/job-posting/ad-sync/position-routing
[Transition hirers]: /use-cases/job-posting/ad-sync/transition-hirers
